// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0f2d7e83","732":"d303f203","977":"fa2e59a4"}[chunkId] + ".chunk.js";
};